import React from "react"
import { LabelGItemBase } from "../../../../components/common/grids"
import { TitleLabel } from "../../../../components/common/titleLabel"
import { AttentionLabel } from "../../../../components/common/attentionLabel"
import { translate } from '../../../../../i18n'

type FieldTitleProps = {
    title: string
    required?: boolean
    isSubField?: boolean
}

const FieldTitle: React.FC<FieldTitleProps> = (props) => {
    const { title, required, isSubField } = props
    
    return (
        <>
            {
                isSubField
                ?   <LabelGItemBase>{translate(title)}</LabelGItemBase>
                :   <div>
                        <TitleLabel>
                            {
                                required && (
                                    <AttentionLabel>*</AttentionLabel>
                                )
                            }
                            {translate(title)}
                        </TitleLabel>
                    </div>
            }
        </>
    )
}

export default FieldTitle